var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import FileUpload from "~/components/common/file-upload.vue";
import { Dependencies } from "~/core/decorator";
import { Emit } from "vue-property-decorator";
import { UserExportService } from "~/services/dataimp-service/user-export.service";
var ImportRoster = /** @class */ (function (_super) {
    __extends(ImportRoster, _super);
    function ImportRoster() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileList = [];
        _this.loading = {
            state: false
        };
        _this.model = {
            fileId: ""
        };
        return _this;
    }
    ImportRoster.prototype.onUploadSuccess = function (id, data) {
        this.model.fileId = data.id;
    };
    ImportRoster.prototype.submit = function () {
        var _this = this;
        if (this.fileList.length === 0) {
            this.$message("请上传文件");
            return;
        }
        this.loading.state = true;
        this.userExportService.uploadUser(this.model.fileId, this.loading).subscribe(function (data) {
            _this.$message.success("正在导入,请关注任务中心");
            _this.success();
        });
    };
    ImportRoster.prototype.close = function () {
        this.reset();
    };
    ImportRoster.prototype.success = function () {
        this.close();
    };
    ImportRoster.prototype.reset = function () {
        var fileupload = this.$refs["file-upload"];
        fileupload.reset();
    };
    __decorate([
        Dependencies(UserExportService)
    ], ImportRoster.prototype, "userExportService", void 0);
    __decorate([
        Emit()
    ], ImportRoster.prototype, "close", null);
    __decorate([
        Emit()
    ], ImportRoster.prototype, "success", null);
    ImportRoster = __decorate([
        Component({
            components: {
                FileUpload: FileUpload
            }
        })
    ], ImportRoster);
    return ImportRoster;
}(Vue));
export default ImportRoster;
